import React, { useEffect, useState } from 'react';
import axios from 'axios';
import GlobalProvider from 'context/global';
import { FirebaseProvider } from 'context/firebase';

export default function Root({ children }) {
  const [srcMap, setSrcMap] = useState(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      axios.get('/src-map.json').then(res => {
        window.srcMap = res.data;
        setSrcMap(true);
      });
    }
  }, []);
  return (
    <GlobalProvider srcMap={srcMap}>
      <FirebaseProvider>{children}</FirebaseProvider>
    </GlobalProvider>
  );
}
